<div style="margin:20px;">
  <div id="titulo">
    <h2>Buscar peticiones {{this.controlGestion}}</h2>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
  </div>
  <h3>Datos de cliente</h3>
  <div style="display: flex;gap: 10px;margin-top:20px; width:100%;">
    <div class="campo">
      <label>Fecha Inicio</label>
      <input matInput [matDatepicker]="fInicio" (click)="fInicio.open()" [(ngModel)]="this.fechaInicio" >
      <mat-datepicker #fInicio></mat-datepicker>
    </div>
    <div class="campo">
      <label>Fecha Fin</label>
      <input matInput [matDatepicker]="fFin" (click)="fFin.open()" [(ngModel)]="this.fechaFin" >
      <mat-datepicker #fFin></mat-datepicker>
    </div>
    <div class="campo">
      <label>Estado</label>
      <mat-select style="display:block;min-width: 0;width: 100%;" [(ngModel)]="this.estado">
        <mat-option value="0">0-Pendientes</mat-option>
        <mat-option value="1">1-Gestionadas</mat-option>
        <mat-option value="2">2-Rellamadas</mat-option>
        <mat-option value="9">9-Todas</mat-option>
      </mat-select>
    </div>
    <div class="campo">
      <label>Matrícula</label>
      <input matInput [(ngModel)]="this.matricula">
    </div>
    <div class="campo">
      <label>Siniestro</label>
      <input matInput [(ngModel)]="this.siniestro">
    </div>
    <div class="campo">
      <label>Teléfono</label>
      <input matInput [(ngModel)]="this.telefono" type="tel" maxlength="9">
    </div>
    <div class="campo" >
      <label></label>
      <a class="btnCCOscuro" mat-flat-button style="width:100%;max-height:50%;padding:0" (click)="buscar()" >Buscar</a>
    </div>
  </div>
  <mat-dialog-content style=" display:flex;justify-content:center ; width: 100%;height:440px;padding: 0;padding-top: 10px;" >
    <!--tabla con el listado de peticiones encontradas-->
    <div id="tablaContainer">
      <table mat-table class="tabla-art" [dataSource]="dataSource" matSort>
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" >
          <th mat-header-cell *matHeaderCellDef style="background: white;" mat-sort-header>{{column.replaceAll("_"," ")}}</th>
          <td mat-cell *matCellDef="let element"
              [style.background-color]="element.isPressed ? '#294634' : (column === 'gestion' ? '#c5efd9' : '')"
              (click)="gestionLlamada(element, column)">
            <a *ngIf="column === 'gestion'"
               mat-flat-button
               (mousedown)="setPressed(element, true, $event)"
               (mouseup)="setPressed(element, false, $event)"
               (mouseleave)="setPressed(element, false, $event)"
               style="font-weight: bold; border-radius: 0;"
               [style.background-color]="element.isPressed ? '#294634' : '#c5efd9'"
               [style.color]="element.isPressed ? '#c5efd9' : '#294634'">Gestionar</a>
            <span *ngIf="column !== 'gestion'"
                  style="font-size: 14px !important;">{{element[column]}}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-progress-bar *ngIf="mostrarCarga" mode="indeterminate"></mat-progress-bar>
  <mat-paginator class="paginador" [pageSizeOptions]="[10, 25, 100]" [length]="dataSource.data.length" [pageSize]="10" [showFirstLastButtons]="true" #paginator (page)="onPageChange($event)"></mat-paginator>

</div>
